(function () {
  'use strict';

  // ── Mobile nav ────────────────────────────────────────────────────────────
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav-close');

  function openNav() {
    mobileNav.classList.add('open');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
  }
  function closeNav() {
    mobileNav.classList.remove('open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
  }

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.contains('open') ? closeNav() : openNav();
    });
    if (mobileClose) mobileClose.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeNav();
    });
  }

  // ── Mobile filter sidebar toggle ─────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      var sidebar = document.querySelector('.filters');
      if (sidebar) sidebar.classList.toggle('open');
    }
  });

  // ── Qty +/- buttons ──────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var wrap = (dec || inc).closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (dec && val > 1) input.value = val - 1;
    if (inc) input.value = val + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ── Product page variant selection ───────────────────────────────────────
  var productForm = document.getElementById('product-form');
  if (productForm) {
    var dataEl = document.getElementById('variant-data');
    if (dataEl) {
      var variants = JSON.parse(dataEl.textContent);
      var variantInput = productForm.querySelector('[name="id"]');
      var priceNow = document.getElementById('price-now');
      var priceWas = document.getElementById('price-was');
      var priceSave = document.getElementById('price-save');
      var stockEl = document.getElementById('stock-status');
      var addBtn = document.getElementById('add-to-cart-btn');
      var selectedOptions = {};

      function fmt(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
        });
      }

      function applyVariant(v) {
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (priceNow) priceNow.textContent = fmt(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (priceWas) { priceWas.textContent = fmt(v.compare_at_price); priceWas.style.display = ''; }
          if (priceSave) {
            var savings = v.compare_at_price - v.price;
            var pct = Math.round(savings / v.compare_at_price * 100);
            priceSave.textContent = 'Save ' + fmt(savings) + ' · ' + pct + '%';
            priceSave.style.display = '';
          }
        } else {
          if (priceWas) priceWas.style.display = 'none';
          if (priceSave) priceSave.style.display = 'none';
        }
        if (addBtn) {
          if (v.available) {
            addBtn.textContent = 'Add to cart · ' + fmt(v.price);
            addBtn.disabled = false;
            addBtn.style.opacity = '';
          } else {
            addBtn.textContent = 'Sold out';
            addBtn.disabled = true;
            addBtn.style.opacity = '0.5';
          }
        }
        if (stockEl) {
          if (v.available) {
            stockEl.className = 'stock';
            stockEl.textContent = v.inventory_quantity > 0
              ? 'In stock · ' + v.inventory_quantity + ' ready to ship'
              : 'Available';
          } else {
            stockEl.className = 'out-of-stock';
            stockEl.textContent = 'Out of stock';
          }
        }
      }

      var first = variants.find(function (v) { return v.available; }) || variants[0];
      if (first) first.options.forEach(function (o, i) { selectedOptions[i] = o; });
      applyVariant(first);

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-index][data-option-value]');
        if (!btn || !btn.closest('#product-form')) return;
        var idx = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[idx] = btn.dataset.optionValue;
        var group = btn.closest('[data-option-group]');
        if (group) group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var labelEl = document.querySelector('[data-option-label="' + idx + '"]');
        if (labelEl) labelEl.textContent = btn.dataset.optionValue;
        applyVariant(findVariant());
      });
    }
  }

  // ── Gallery thumbnails ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var src = thumb.dataset.thumb;
    var srcset = thumb.dataset.thumbSrcset || '';
    var mainImg = main.querySelector('img');
    if (mainImg && src) { mainImg.src = src; mainImg.srcset = srcset; }
  });

  // ── Cart quantity change → submit ─────────────────────────────────────────
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-cart-qty]')) {
      var form = document.getElementById('cart-form');
      if (form) form.submit();
    }
  });

  // ── Sort dropdown → reload ────────────────────────────────────────────────
  var sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

})();
